{
  "dashboard": "Tableau de bord du gouvernement",
  "applications": "Applications",
  "oversight": "Surveillance du registre",
  "dashboard_page": {
    "title": "Aperçu du tableau de bord",
    "subtitle": "Gestion de l'accès à l'ADN du gouvernement",
    "admin_user": "Utilisateur administrateur",
    "stats": {
      "registered_projects": "Projets enregistrés",
      "pending_approvals": "Approbations en attente",
      "credits_issued": "Crédits émis",
      "active_transfers": "Transferts actifs",
      "pending_applications": "Demandes en attente",
      "certificates_issued": "Certificats délivrés",
      "active_projects": "Projets actifs",
      "open_grievances": "Griefs ouverts"
    },
    "quick_actions": {
      "application_queue": {
        "title": "File d'attente des demandes",
        "pin": "Note d'information sur le projet",
        "pdd": "Document de conception du projet",
        "authorization": "Demande d'autorisation",
        "pending": "En attente",
        "review": "Révision",
        "approved": "Approuvé"
      },
      "recent_certificates": {
        "title": "Certificats récents",
        "credit_registration": "Enregistrement de crédit",
        "letter_authorization": "Lettre d'autorisation",
        "credit_cancellation": "Annulation de crédit",
        "issued": "Émis",
        "processing": "En cours de traitement"
      }
    },
    "registry_overview": {
      "title": "Surveillance du registre",
      "verified_emissions": "Émissions vérifiées",
      "retired_credits": "Crédits retirés",
      "pending_transfer": "Transfert en attente",
      "tco2e": "tCO2e",
      "credits": "Crédits"
    },
    "ndc_allocation": {
      "title": "Allocation NDC",
      "total_allocation": "Allocation totale",
      "renewable_energy": "Énergie renouvelable",
      "forestry": "Foresterie",
      "agriculture": "Agriculture"
    },
    "buffer_account": {
      "title": "Compte tampon",
      "national_buffer": "Tampon national",
      "transaction_account": "Compte de transaction",
      "available_credits": "Crédits disponibles"
    },
    "pending_approvals": {
      "title": "Approbations de projet en attente",
      "view_all": "Afficher toutes les demandes",
      "project_id": "ID du projet",
      "project_name": "Nom du projet",
      "developer": "Développeur",
      "submitted": "Soumis",
      "type": "Type",
      "status": "Statut",
      "actions": "Actions",
      "review": "Révision",
      "approve": "Approuver",
      "reject": "Rejeter",
      "under_review": "En cours de révision",
      "documentation_required": "Documentation requise",
      "technical_review": "Révision technique"
    },
    "international_transfers": {
      "title": "Transferts internationaux",
      "view_all_transfers": "Afficher tous les transferts",
      "transfer_id": "ID de transfert",
      "from_country": "Du pays",
      "to_country": "Au pays",
      "credits": "Crédits",
      "date": "Date",
      "status": "Statut",
      "authorize": "Autoriser",
      "authorized": "Autorisé",
      "pending_authorization": "Autorisation en attente"
    },
    "registry_insights": {
      "title": "Aperçus du registre",
      "total_projects": "Total des projets",
      "this_month": "ce mois-ci",
      "compliance_rate": "Taux de conformité",
      "avg_processing_time": "Temps de traitement moyen",
      "days": "jours"
    }
  },
  "register_page": {
    "title": "Gouvernement / Enregistrement ADN",
    "subtitle": "Accès à la surveillance administrative et à la gestion réglementaire pour les autorités nationales désignées",
    "dna_requirements": {
      "title": "Exigences de l'autorité ADN",
      "official_designation": "Désignation officielle du gouvernement en tant qu'ADN",
      "unfccc_coordination": "Coordination du registre national de la CCNUCC",
      "legal_authority": "Autorité légale pour la surveillance du marché du carbone",
      "article6_mandate": "Mandat de mise en œuvre de l'article 6"
    },
    "admin_functions": {
      "title": "Fonctions administratives",
      "project_approval": "Approbation et autorisation de projet",
      "registry_oversight": "Surveillance et suivi du registre",
      "transfer_authorization": "Autorisation de transfert international",
      "compliance_enforcement": "Outils de conformité et d'application"
    },
    "access_levels": {
      "title": "Niveaux d'accès",
      "observer": {
        "title": "Observateur",
        "description": "Accès en lecture seule au registre"
      },
      "administrator": {
        "title": "Administrateur",
        "description": "Surveillance réglementaire complète"
      }
    },
    "application_process": {
      "title": "Processus de demande",
      "step1": "Soumettre la lettre de désignation officielle de l'ADN",
      "step2": "Fournir la documentation d'autorisation de la CCNUCC",
      "step3": "Remplir les exigences d'intégration technique",
      "step4": "Subir une vérification de l'habilitation de sécurité"
    },
    "contact_info": {
      "title": "Pour les demandes d'enregistrement d'ADN, veuillez contacter :",
      "email": "E-mail",
      "phone": "Téléphone",
      "office_hours": "Heures de bureau : du lundi au vendredi, de 9h00 à 17h00 UTC"
    },
    "actions": {
      "request_access": "Demander l'accès au portail ADN",
      "download_requirements": "Télécharger le document des exigences"
    },
    "registration_status": "L'inscription d'accès gouvernemental est actuellement en développement. Veuillez revenir bientôt.",
    "buttons": {
      "register_new_dna": "Enregistrer nouvel ADN",
      "access_existing_portal": "Accéder au portail existant"
    }
  },
  "sidebar": {
    "portal_title": "Portail d'accès ADN",
    "portal_subtitle": "Tableau de bord du gouvernement",
    "dashboard": "Tableau de bord",
    "application_queue": "File d'attente des demandes",
    "certificates": "Certificats",
    "registry_oversight": "Surveillance du registre",
    "grievance_management": "Gestion des griefs",
    "doe_licenses": "Licences EOD",
    "unfccc_reporting": "Rapports CCNUCC",
    "administration": "Administration",
    "settings": "Paramètres",
    "logout": "Déconnexion"
  },
  "application_queue": {
    "title": "File d'attente des demandes",
    "subtitle": "Demandes en attente - PIN, PDD et autorisations",
    "filters": {
      "application_type": "Type de demande :",
      "all_types": "Tous les types",
      "pin": "PIN",
      "pdd": "PDD",
      "authorization": "Autorisation",
      "status": "Statut :",
      "all_status": "Tous les statuts",
      "pending_review": "En attente d'examen",
      "under_review": "En cours d'examen",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "date_range": "Plage de dates :",
      "to": "à",
      "filter": "Filtrer"
    },
    "stats": {
      "total_applications": "Total des demandes",
      "pin_applications": "Demandes de PIN",
      "pdd_applications": "Demandes de PDD",
      "authorizations": "Autorisations"
    },
    "table": {
      "title": "Demandes en attente",
      "export": "Exporter",
      "new_review": "Nouvel examen",
      "columns": {
        "application_id": "ID de la demande",
        "type": "Type",
        "project_name": "Nom du projet",
        "applicant": "Demandeur",
        "submitted": "Soumis",
        "status": "Statut",
        "priority": "Priorité",
        "actions": "Actions"
      },
      "priority": {
        "high": "Haute",
        "medium": "Moyenne",
        "low": "Basse"
      },
      "actions": {
        "review": "Révision",
        "details": "Détails",
        "reopen": "Rouvrir"
      }
    },
    "pagination": {
      "showing": "Affichage",
      "to": "à",
      "of": "de",
      "results": "résultats",
      "previous": "Précédent",
      "next": "Suivant"
    }
  },
  "certificates": {
    "title": "Délivrance de certificats et de lettres",
    "subtitle": "Émettre des documents CR, LOA et CCI",
    "action_buttons": {
      "issue_cr": "Émettre un enregistrement de crédit (CR)",
      "issue_loa": "Émettre une lettre d'autorisation (LOA)",
      "issue_cci": "Émettre une annulation de crédit (CCI)"
    },
    "filters": {
      "search_placeholder": "Rechercher par ID, nom de projet ou organisation",
      "all_certificate_types": "Tous les types de certificats",
      "credit_registration": "Enregistrement de crédit (CR)",
      "letter_authorization": "Lettre d'autorisation (LOA)",
      "credit_cancellation": "Annulation de crédit (CCI)",
      "all_status": "Tous les statuts",
      "draft": "Brouillon",
      "pending_approval": "En attente d'approbation",
      "issued": "Émis",
      "cancelled": "Annulé",
      "filter": "Filtrer"
    },
    "stats": {
      "total_issued": "Total émis",
      "cr_documents": "Documents CR",
      "loa_documents": "Documents LOA",
      "cci_documents": "Documents CCI"
    },
    "table": {
      "title": "Certificats et lettres récents",
      "columns": {
        "document_id": "ID du document",
        "type": "Type",
        "project_name": "Nom du projet",
        "organization": "Organisation",
        "issue_date": "Date d'émission",
        "status": "Statut",
        "actions": "Actions"
      },
      "document_types": {
        "cr": "CR",
        "loa": "LOA",
        "cci": "CCI"
      }
    },
    "pagination": {
      "showing": "Affichage",
      "of": "de",
      "certificates": "certificats",
      "previous": "Précédent",
      "next": "Suivant"
    }
  },
  "registry_oversight": {
    "title": "Surveillance du registre",
    "subtitle": "Suivi des projets et gestion des crédits",
    "filters": {
      "all_project_types": "Tous les types de projets",
      "renewable_energy": "Énergie renouvelable",
      "forestry": "Foresterie",
      "agriculture": "Agriculture",
      "energy_efficiency": "Efficacité énergétique",
      "all_developers": "Tous les développeurs",
      "all_status": "Tous les statuts",
      "active": "Actif",
      "pending": "En attente",
      "suspended": "Suspendu",
      "all_standards": "Toutes les normes",
      "vcs": "VCS",
      "gold_standard": "Gold Standard",
      "cdm": "MDP",
      "apply_filters": "Appliquer les filtres",
      "export": "Exporter"
    },
    "project_tags": {
      "title": "Étiquettes de projet",
      "article6_eligible": "Éligible à l'article 6.2",
      "in_buffer": "En tampon",
      "pending_transfer": "Transfert en attente"
    },
    "account_ledger": {
      "verified_emissions": {
        "title": "Émissions vérifiées",
        "total_verified": "Total vérifié",
        "this_month": "Ce mois-ci"
      },
      "retired_credits": {
        "title": "Crédits retirés",
        "total_retired": "Total retiré"
      },
      "pending_transfer": {
        "title": "Transfert en attente",
        "awaiting_transfer": "En attente de transfert",
        "processing": "En cours de traitement"
      }
    },
    "projects_table": {
      "title": "Registre de projets",
      "columns": {
        "project_id": "ID du projet",
        "type": "Type",
        "developer": "Développeur",
        "status": "Statut",
        "credits": "Crédits",
        "tags": "Étiquettes",
        "actions": "Actions"
      }
    },
    "ownership_history": {
      "title": "Historique de propriété",
      "credit_transfer": "Transfert de crédit",
      "credit_issuance": "Émission de crédit"
    },
    "pagination": {
      "showing": "Affichage",
      "of": "de",
      "projects": "projets",
      "previous": "Précédent",
      "next": "Suivant"
    }
  },
  "grievance_management": {
    "title": "Gestion des griefs",
    "subtitle": "Suivre et gérer les griefs et les plaintes des projets",
    "new_grievance": "Nouveau grief",
    "stats": {
      "open_grievances": "Griefs ouverts",
      "under_investigation": "En cours d'investigation",
      "resolved_this_month": "Résolu ce mois-ci",
      "avg_resolution_time": "Temps de résolution moyen",
      "days": "jours"
    },
    "filters": {
      "search_placeholder": "Rechercher des griefs...",
      "all_status": "Tous les statuts",
      "open": "Ouvert",
      "under_investigation": "En cours d'investigation",
      "resolved": "Résolu",
      "closed": "Fermé",
      "all_priority": "Toutes les priorités",
      "high": "Haute",
      "medium": "Moyenne",
      "low": "Basse",
      "all_projects": "Tous les projets",
      "filter": "Filtrer"
    },
    "grievance_list": {
      "title": "Griefs actifs",
      "columns": {
        "grievance_id": "ID du grief",
        "project": "Projet",
        "complainant": "Plaignant",
        "category": "Catégorie",
        "priority": "Priorité",
        "status": "Statut",
        "date_submitted": "Date de soumission",
        "actions": "Actions"
      },
      "categories": {
        "environmental": "Environnemental",
        "social_impact": "Impact social",
        "economic": "Économique",
        "procedural": "Procédural"
      },
      "roles": {
        "community_rep": "Représentant de la communauté",
        "local_farmer": "Agriculteur local",
        "traditional_leader": "Chef traditionnel",
        "ngo_representative": "Représentant d'ONG"
      }
    },
    "pagination": {
      "showing": "Affichage",
      "of": "de",
      "grievances": "griefs",
      "previous": "Précédent",
      "next": "Suivant"
    }
  },
  "doe_licenses": {
    "title": "Licences EOD",
    "subtitle": "Gestion des licences d'entité opérationnelle désignée",
    "new_license": "Nouvelle licence",
    "admin_user": "Utilisateur administrateur",
    "search_filters": {
      "search_label": "Recherche",
      "search_placeholder": "Rechercher par nom d'organisation...",
      "status_label": "Statut",
      "all_status": "Tous les statuts",
      "active": "Actif",
      "pending": "En attente",
      "suspended": "Suspendu",
      "expired": "Expiré",
      "license_type_label": "Type de licence",
      "all_types": "Tous les types",
      "validation": "Validation",
      "verification": "Vérification",
      "both": "Les deux",
      "actions_label": "Actions",
      "filter": "Filtrer",
      "export": "Exporter"
    },
    "stats": {
      "total_licenses": "Total des licences",
      "active_licenses": "Licences actives",
      "pending_review": "En attente d'examen",
      "expiring_soon": "Expire bientôt"
    },
    "table": {
      "title": "Registre des licences EOD",
      "columns": {
        "organization": "Organisation",
        "license_id": "ID de licence",
        "type": "Type",
        "contact": "Contact",
        "status": "Statut",
        "expiry_date": "Date d'expiration",
        "actions": "Actions"
      },
      "status_labels": {
        "active": "Actif",
        "pending": "En attente",
        "expiring": "Expire"
      },
      "type_labels": {
        "validation": "Validation",
        "verification": "Vérification",
        "both": "Les deux"
      }
    },
    "pagination": {
      "showing": "Affichage",
      "to": "à",
      "of": "de",
      "results": "résultats",
      "previous": "Précédent",
      "next": "Suivant"
    }
  },
  "unfccc_reporting": {
    "title": "Exportations de rapports CCNUCC",
    "subtitle": "Générer et exporter des rapports CCNUCC et des résumés d'ajustements",
    "admin_user": "Utilisateur administrateur",
    "report_generation": {
      "title": "Générer des rapports CCNUCC",
      "export_all_reports": "Exporter tous les rapports",
      "report_parameters": "Paramètres de rapport",
      "reporting_period_label": "Période de rapport",
      "report_type_label": "Type de rapport",
      "report_types": {
        "full_report": "Rapport complet",
        "summary_report": "Rapport de synthèse",
        "adjustment_report": "Rapport d'ajustement"
      },
      "project_categories_label": "Catégories de projets",
      "categories": {
        "all_categories": "Toutes les catégories",
        "renewable_energy": "Énergie renouvelable",
        "forestry_land_use": "Foresterie et utilisation des terres",
        "agriculture": "Agriculture"
      },
      "article6_status_label": "Statut Article 6.2",
      "article6_options": {
        "article6_eligible": "Éligible à l'Article 6.2",
        "in_buffer": "En tampon",
        "pending_transfer": "Transfert en attente"
      }
    },
    "report_preview": {
      "title": "Aperçu du rapport",
      "estimated_report_size": "Taille estimée du rapport",
      "total_projects": "Total des projets",
      "total_credits": "Total des crédits",
      "last_updated": "Dernière mise à jour",
      "generate_pdf_report": "Générer un rapport PDF",
      "generate_excel_report": "Générer un rapport Excel",
      "generate_csv_report": "Générer un rapport CSV"
    },
    "corresponding_adjustments": {
      "title": "Résumé des ajustements correspondants",
      "refresh_data": "Actualiser les données",
      "stats": {
        "total_adjustments": "Total des ajustements",
        "positive_adjustments": "Ajustements positifs",
        "negative_adjustments": "Ajustements négatifs",
        "pending_adjustments": "Ajustements en attente",
        "tco2e": "tCO2e"
      },
      "table": {
        "columns": {
          "project_id": "ID du projet",
          "project_name": "Nom du projet",
          "sector": "Secteur",
          "adjustment_type": "Type d'ajustement",
          "amount_tco2e": "Montant (tCO2e)",
          "status": "Statut",
          "date": "Date"
        },
        "adjustment_types": {
          "positive": "Positif",
          "negative": "Négatif"
        },
        "status_labels": {
          "processed": "Traité",
          "pending": "En attente"
        }
      }
    },
    "export_history": {
      "title": "Historique des exportations",
      "filter": "Filtrer",
      "status": {
        "completed": "Terminé"
      },
      "download": "Télécharger"
    }
  },
  "administration": {
    "title": "Administration",
    "subtitle": "Gestion des utilisateurs et configuration du système",
    "admin_user": "Utilisateur administrateur",
    "tabs": {
      "user_management": "Gestion des utilisateurs",
      "sector_management": "Gestion des secteurs",
      "ndc_allocation": "Allocation NDC",
      "buffer_accounts": "Comptes tampons",
      "transaction_accounts": "Comptes de transaction"
    },
    "userManagement": {
      "title": "Gestion des utilisateurs",
      "form": {
        "title": "Ajouter un nouvel utilisateur",
        "labels": {
          "organizationName": "Nom de l'organisation",
          "address": "Adresse",
          "contactNumber": "Numéro de contact",
          "pointOfContactName": "Nom du point de contact",
          "role": "Rôle",
          "contactEmail": "E-mail de contact",
          "phoneNumber": "Numéro de téléphone",
          "username": "Nom d'utilisateur",
          "password": "Mot de passe"
        },
        "placeholders": {
          "organizationName": "Entrer le nom de l'organisation",
          "address": "Entrer l'adresse",
          "contactNumber": "Entrer le numéro de contact",
          "pointOfContactName": "Entrer le nom du contact",
          "contactEmail": "Entrer l'adresse e-mail",
          "phoneNumber": "Entrer le numéro de téléphone",
          "username": "Entrer le nom d'utilisateur",
          "password": "Entrer le mot de passe"
        },
        "buttons": {
          "addUser": "Ajouter un utilisateur"
        }
      },
      "userList": {
        "title": "Gérer les utilisateurs",
        "search": {
          "placeholder": "Rechercher des utilisateurs...",
          "allRoles": "Tous les rôles"
        },
        "table": {
          "headers": {
            "organization": "Organisation",
            "contactPerson": "Personne de contact",
            "role": "Rôle",
            "email": "E-mail",
            "status": "Statut",
            "actions": "Actions"
          }
        },
        "pagination": {
          "showing": "Affichage",
          "to": "à",
          "of": "de",
          "results": "résultats",
          "previous": "Précédent",
          "next": "Suivant"
        }
      },
      "roles": {
        "selectRole": "Sélectionner un rôle",
        "admin": "Administrateur",
        "reviewer": "Réviseur",
        "operator": "Opérateur",
        "viewer": "Visualiseur"
      },
      "status": {
        "active": "Actif",
        "inactive": "Inactif"
      }
    },
    "sectorManagement": {
      "title": "Gestion des méthodologies",
      "controls": {
        "title": "Gestion des Méthodologies",
        "buttons": {
          "addMethodology": "Ajouter une Méthodologie",
          "export": "Exporter"
        },
        "filters": {
          "sectorLabel": "Filtrer par Secteur",
          "allSectors": "Tous les Secteurs",
          "renewableEnergy": "Énergies Renouvelables",
          "forestry": "Foresterie",
          "agriculture": "Agriculture",
          "wasteManagement": "Gestion des Déchets",
          "transportation": "Transport",
          "industrial": "Industriel",
          "waste": "Déchets",
          "statusLabel": "Statut d'Approbation",
          "allStatus": "Tous les Statuts",
          "approved": "Approuvé",
          "notApproved": "Non Approuvé",
          "underReview": "En Cours d'Examen",
          "searchLabel": "Rechercher",
          "searchPlaceholder": "Rechercher des méthodologies..."
        }
      },
      "approvedMethodologies": {
        "title": "Méthodologies approuvées pour la juridiction",
        "count": "Méthodologies",
        "table": {
          "headers": {
            "methodologyId": "ID de méthodologie",
            "sector": "Secteur",
            "title": "Titre",
            "version": "Version",
            "approvalDate": "Date d'approbation",
            "actions": "Actions"
          }
        }
      },
      "nonApprovedMethodologies": {
        "title": "Méthodologies NON approuvées pour la juridiction",
        "count": "Méthodologies",
        "table": {
          "headers": {
            "methodologyId": "ID de méthodologie",
            "sector": "Secteur",
            "title": "Titre",
            "reason": "Raison",
            "reviewDate": "Date de révision",
            "actions": "Actions"
          }
        },
        "rejectionReasons": {
          "incompatiblePolicy": "Incompatible avec la politique nationale",
          "technicalRequirements": "Exigences techniques non satisfaites"
        }
      },
      "sectorsNotApproved": {
        "title": "Secteurs NON approuvés",
        "addButton": "Ajouter un secteur restreint",
        "restrictions": {
          "permanentlyRestricted": "Restreint de façon permanente",
          "policyRestricted": "Restreint par politique",
          "underReview": "En cours de révision"
        },
        "sectors": {
          "coalMining": "Extraction de charbon",
          "oilGasExtraction": "Extraction de pétrole et de gaz",
          "nuclearEnergy": "Énergie nucléaire"
        },
        "descriptions": {
          "coalMining": "Extraction de charbon et activités connexes",
          "oilGasExtraction": "Extraction de pétrole et de gaz naturel",
          "nuclearEnergy": "Activités de production d'énergie nucléaire"
        }
      }
    },
    "ndcAllocation": {
        "buttons": {
          "saveChanges": "Enregistrer les Modifications",
          "reset": "Réinitialiser"
        },
        "lastUpdated": "Dernière mise à jour:",
        "allocation": {
          "title": "Pourcentages d'Allocation CDN",
          "total": "Total:",
          "applyToAll": "Appliquer à Tous les Secteurs"
        },
        "sectors": {
          "renewableEnergy": "Énergies Renouvelables",
          "forestryLandUse": "Foresterie et Utilisation des Terres",
          "agriculture": "Agriculture",
          "transportation": "Transport",
          "industrialProcesses": "Processus Industriels",
          "wasteManagement": "Gestion des Déchets"
        },
        "bufferAccount": {
          "title": "Compte Tampon National",
          "total": "Total:",
          "applyToAll": "Appliquer à Tous les Secteurs"
        },
        "transactionAccount": {
          "title": "Compte de Transaction National",
          "total": "Total:",
          "applyToAll": "Appliquer à Tous les Secteurs"
        },
        "placeholders": {
          "percentage": "%"
        }
      },
      "bufferAccounts": {
        "overview": {
          "totalBufferAllocation": "Allocation Totale du Tampon",
          "activeSectors": "Secteurs Actifs",
          "bufferCredits": "Crédits Tampon"
        },
        "configuration": {
          "title": "Configuration du Compte Tampon",
          "saveChanges": "Enregistrer les Modifications"
        },
        "globalSettings": {
          "title": "Paramètres Globaux du Tampon",
          "applyToAllSectors": "Appliquer à tous les secteurs",
          "globalPercentage": "Pourcentage Global:"
        },
        "sectorSettings": {
          "title": "Allocation Tampon Spécifique par Secteur",
          "enableSectorSpecific": "Activer l'allocation spécifique par secteur"
        },
        "sectors": {
          "renewableEnergy": {
            "title": "Énergies Renouvelables",
            "description": "Projets solaires, éoliens, hydroélectriques"
          },
          "forestryLandUse": {
            "title": "Foresterie et Utilisation des Terres",
            "description": "Projets REDD+, de reboisement"
          },
          "agriculture": {
            "title": "Agriculture",
            "description": "Agriculture durable, élevage"
          },
          "wasteManagement": {
            "title": "Gestion des Déchets",
            "description": "Gaz de décharge, compostage"
          },
          "manufacturing": {
            "title": "Fabrication",
            "description": "Efficacité industrielle, changement de combustible"
          },
          "transport": {
            "title": "Transport",
            "description": "Changement modal, améliorations d'efficacité"
          }
        },
        "summary": {
          "activeAllocations": {
            "title": "Allocations Tampons Actives",
            "forestryCredits": "crédits en tampon",
            "agricultureCredits": "crédits en tampon",
            "transportCredits": "crédits en tampon"
          },
          "activity": {
            "title": "Activité du Compte Tampon",
            "creditsAdded": "Crédits Ajoutés",
            "creditsReleased": "Crédits Libérés",
            "netChange": "Changement Net",
            "last30Days": "30 derniers jours"
          }
        }
      },
      "transactionAccounts": {
        "summary": {
          "totalAllocation": "Allocation Totale",
          "activeSectors": "Secteurs Actifs",
          "remaining": "Restant"
        },
        "globalSettings": {
          "title": "Paramètres d'Allocation Globale",
          "applyToAllSectors": "Appliquer à Tous les Secteurs",
          "percentage": "Pourcentage:",
          "sectorSpecificAllocation": "Allocation Spécifique par Secteur",
          "buttons": {
            "reset": "Réinitialiser",
            "applyGlobal": "Appliquer Globalement"
          }
        },
        "sectorAllocation": {
          "title": "Allocation par Secteur",
          "buttons": {
            "addSector": "Ajouter Secteur",
            "saveChanges": "Enregistrer les Modifications"
          },
          "table": {
            "headers": {
              "sectorName": "Nom du Secteur",
              "currentAllocation": "Allocation Actuelle",
              "newAllocation": "Nouvelle Allocation (%)",
              "status": "Statut",
              "actions": "Actions"
            }
          },
          "sectors": {
            "renewableEnergy": "Énergies Renouvelables",
            "forestryLandUse": "Foresterie et Utilisation des Terres",
            "agriculture": "Agriculture",
            "wasteManagement": "Gestion des Déchets",
            "transportation": "Transport"
          },
          "status": {
            "active": "Actif",
            "pending": "En Attente",
            "inactive": "Inactif"
          }
        },
        "footer": {
          "totalAllocated": "Total Alloué:",
          "remaining": "Restant:",
          "buttons": {
            "cancel": "Annuler",
            "saveAllChanges": "Enregistrer Toutes les Modifications"
          }
        }
      }
    }
  }